import { Component, Output, EventEmitter } from "@angular/core";

import { TabComponent } from "./tab.component";

@Component({
    selector: 'tabs',
    templateUrl: "./tabs.component.html",
    styleUrls: ['./tabs.component.scss'],
    standalone: false
})

export class TabsComponent {
    tabs: TabComponent[] = [];
    @Output() tabClicked = new EventEmitter<TabComponent>();


    addTab(tab: TabComponent) {

        if (this.tabs.length === 0) {
            tab.active = true;
        };

        this.tabs.push(tab);
    }

    onTabClicked(tab: TabComponent) {
        this.tabs.forEach((tab) => {
            tab.active = false;
        });

        tab.active = true;

        this.tabClicked.emit(tab);
    }
}
